// extracted by mini-css-extract-plugin
export default {"introduction":"Introduction_introduction__doL37","liAnchor":"Introduction_liAnchor__OwI2z"};